import { c as _c } from "react/compiler-runtime";
import { cx } from 'class-variance-authority';
import Button from '../../../button';
import type { DialogPageButton } from '../../dialog-page.types';
type FooterProps = {
  primaryButton?: DialogPageButton;
  secondaryButton?: DialogPageButton;
};
const Footer = t0 => {
  const $ = _c(11);
  const {
    primaryButton,
    secondaryButton
  } = t0;
  const t1 = primaryButton && secondaryButton;
  const t2 = !(primaryButton && secondaryButton);
  let t3;
  if ($[0] !== t1 || $[1] !== t2) {
    t3 = cx("flex gap-2 w-full", {
      "justify-between": t1,
      "justify-end": t2
    });
    $[0] = t1;
    $[1] = t2;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] !== secondaryButton) {
    t4 = secondaryButton && <Button id={secondaryButton.id} disabled={secondaryButton.disabled} form={secondaryButton.form} loading={secondaryButton.loading} loadingAriaLabel={secondaryButton.loadingAriaLabel} onClick={secondaryButton.onClick} type={secondaryButton.type} variant={secondaryButton.variant || "secondary"}>{secondaryButton.label}</Button>;
    $[3] = secondaryButton;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] !== primaryButton) {
    t5 = primaryButton && <Button id={primaryButton.id} disabled={primaryButton.disabled} form={primaryButton.form} loading={primaryButton.loading} loadingAriaLabel={primaryButton.loadingAriaLabel} onClick={primaryButton.onClick} type={primaryButton.type} variant={primaryButton.variant || "primary"}>{primaryButton.label}</Button>;
    $[5] = primaryButton;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  let t6;
  if ($[7] !== t3 || $[8] !== t4 || $[9] !== t5) {
    t6 = <footer className="box-content flex relative flex-col justify-between items-center px-3 py-2 w-full border-t flex-0 border-tertiary md:flex-row-reverse md:px-6 bg-background-primary"><div className="flex items-center w-full"><div className={t3}>{t4}{t5}</div></div></footer>;
    $[7] = t3;
    $[8] = t4;
    $[9] = t5;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  return t6;
};
export default Footer;